import { isClientOptingReact } from 'owa-optin';
import { migratePersistedAddins } from 'owa-mail-addins';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';

export default function checkAndUpdatePersistedAddins() {
    if (isClientOptingReact() && !isConsumer()) {
        migratePersistedAddins();
    }
}
